<template>
  <aw-dropdown
    placement="bottom-end"
    :offset="[0, 6]"
    class="relative cursor-pointer hidden lg:block"
  >
    <template v-slot:btn="{ toggle }">
      <div 
        @click="toggle"
        class="flex"
      >
        <!--
        <img
          class="rounded-full w-6 h-6"
          src="https://i.pinimg.com/originals/97/e4/2a/97e42a82fc7911961d3ca55f54d1372c.jpg"
          alt=""
        />
        -->
        <ui-pictogram 
          size="sm" 
          :force-content="inicials" 
          :force-title="fullname"
          class="!bg-transparent !text-gray-200 !border-gray-200"
        />
      </div>
    </template>
    <template v-slot:dropdown="{ opened, dropdown }">
      <div
        v-show="opened"
        :ref="dropdown"
        class="Dropdown Dropdown--Short Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
      >
        <nav class="p-0">
          <slot></slot>
        </nav>
      </div>
    </template>
  </aw-dropdown>
</template>

<script>
export default {
  props: {
    inicials: String,
    fullname: String,
  },
};
</script>

<style lang="scss" scoped></style>
